import React from 'react'
import { number, func } from 'prop-types'
import classNames from 'classnames'
import '@assets/css/components/product/product-pagination.sass'

export class Pagination extends React.Component {
  updatePage(newPage) {
    const { currentPage, applyStateChange } = this.props
    const page = newPage ?? currentPage
    applyStateChange('page', page)
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
    try {
      document.getElementById('productResultsWrapper').focus()
      window.scrollTo(0, 0)
    } catch (error) {}
  }

  render() {
    const { nbPages, padding, currentPage } = this.props
    const start = currentPage - padding > 0 ? currentPage - padding : 1
    const end = currentPage + padding + 1 < nbPages ? currentPage + padding + 1 : nbPages
    const pageRange = Array.from({ length: end + 1 - start }, (a, b) => b + start)
    const isCurrent = page => currentPage === page

    const pageOptions = pageRange.map(page => (
      <li key={page}>
        <button
          type="button"
          onClick={() => this.updatePage(page)}
          className={classNames({ 'active-page': isCurrent(page) })}
          aria-current={isCurrent(page)}
        >
          <span className="hide508">Page</span>
          {page}
        </button>
      </li>
    ))

    if (nbPages <= 1) {
      return null
    }

    return (
      <div className="plp-pagination">
        <nav role="navigation" aria-label="Pagination">
          {currentPage > 1 && (
            <button
              type="button"
              className="arrow"
              aria-label="Previous Page"
              onClick={() => this.updatePage(currentPage - 1)}
            >
              <span aria-hidden="true">‹</span>
            </button>
          )}
          <ul>{pageOptions}</ul>
          {currentPage < nbPages && (
            <button
              type="button"
              className="arrow"
              aria-label="Next Page"
              onClick={() => this.updatePage(currentPage + 1)}
            >
              <span aria-hidden="true">›</span>
            </button>
          )}
        </nav>
      </div>
    )
  }
}

Pagination.propTypes = {
  nbPages: number,
  padding: number,
  currentPage: number,
  applyStateChange: func,
}

export default Pagination
